import { render, staticRenderFns } from "./proxy_manager.vue?vue&type=template&id=f287e8ea&scoped=true"
import script from "./proxy_manager.vue?vue&type=script&lang=ts"
export * from "./proxy_manager.vue?vue&type=script&lang=ts"
import style0 from "./proxy_manager.vue?vue&type=style&index=0&id=f287e8ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f287e8ea",
  null
  
)

export default component.exports